import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { readConfig } from './config';
import './styles.css';

async function boot() {
  const mount = document.getElementById('restaurant-inspections-app');
  if (!mount) {
    console.warn('[snhd-eh-restaurants] mount #restaurant-inspections-app not found');
    return;
  }

  if (import.meta.env.DEV) {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  const config = readConfig(mount);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    },
  });

  createRoot(mount).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App config={config} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
